import { createLogger } from "@aviv-unified-frontend/runtime/monitoring";
import { SHELL_ID } from "@aviv-unified-frontend/internal";

export const logger = createLogger(SHELL_ID);
